import { AppTitle } from "@/app/components/header/app-title";
import { LoginForm } from "@/app/components/login/form";

export default function Login() {
  return (
    <div className="flex flex-col w-screen h-screen relative">
      <header
        className="w-full flex items-center justify-center h-header box-content pt-[var(--safe-area-top)] fixed top-0 right-0 left-0 z-20 bg-background border-b electron-drag"
        style={{
          paddingLeft: "max(1rem, var(--safe-area-left))",
          paddingRight: "max(1rem, var(--safe-area-right))",
        }}
      >
        <AppTitle />
      </header>
      <main className="flex flex-col w-full h-full justify-center items-center">
        <LoginForm />
      </main>
    </div>
  );
}
